import { accountNumberValidationRegex, ifscValidationRegex, beneficiaryNameRegex, upiHandleValidationRegex } from "../app_methods";
import { get, post, put, patch } from "../services/HttpService";


export class Beneficiary {
    constructor(beneficiaryObject = {}) {
        this.set(beneficiaryObject);
    };

    static validations = {
        "uuid": [],
        "contact_id": [],
        "beneficiary_type": [],
        "beneficiary_name": [
            { required: true, message: "Name is required." },
            { pattern: beneficiaryNameRegex(), message: "Please enter a valid Beneficiary Name." },
            { min: 1, message: "Must be atleast 1 characters long" },
            { max: 100, message: "Can be of maximum 100 characters" }
        ],
        "account_holder_name": [
            { required: true, message: "Name is required." },
            { pattern: beneficiaryNameRegex(), message: "Please enter a valid Account Holder Name." },
            { min: 1, message: "Must be atleast 1 characters long" },
            { max: 100, message: "Can be of maximum 100 characters" }
        ],
        "account_number": [
            { required: true, message: "Account Number is required." },
            { pattern: accountNumberValidationRegex(), message: "Please enter a valid account number." },
            { min: 3, message: "Must be atleast 3 characters long" },
            { max: 26, message: "Maximum 26 characters allowed" }
        ],
        "ifsc": [
            { required: true, message: "Account IFSC Code is required." },
            { pattern: ifscValidationRegex(), message: "Please enter a valid IFSC." },    
            { len:11, message: "IFSC must be of 11 characters." }
        ],
        "upi_handle": [
            { required: true, message: "UPI Handle is required." },
            { pattern: upiHandleValidationRegex(), message: "UPI Handle is invalid." }
        ],
        "created_at": [],
        "threshold_percentage": [
            {pattern: /^100(\.0{1,2})?$|(^([1-9]([0-9])?)(\.[0-9]{1,2})?)$/, message: "Please enter a valid Percentage"},
            { max: 100, message: "Maximum 100 percentage is allowed" }
        ]
    };

    /**
     * @memberof Beneficiary
     * @type API
     * @returns Promise
     */
    static list = (queryData = {}, config = {}) => {
        return get(`v1/internal/beneficiaries/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof Beneficiary
     * @type API
     * @returns Promise
     */
        static list_v2 = (queryData = {}, config = {}) => {
            return get(`v2/internal/beneficiaries/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
        };

    /**
     * @memberof Beneficiary
     * @type API
     * @returns Promise
     */
    retreive = (queryData = {}, config = {}) => {
        return get(`v1/internal/beneficiaries/${this.uuid}/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof Beneficiary
     * @type API
     * @returns Promise
     */
    save = () => {
        let queryData = this.get();
        // if (queryData.account_number && queryData.account_number.startsWith("EASEBZ")) return Object.create({ success: false, data: { message: "Invalid Account Number." } });
        if (queryData.id) return put(`v1/internal/beneficiaries/${this.id}/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
        return post(`v1/internal/beneficiaries/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof Beneficiary
     * @type API
     * @returns Promise
     */
    updateStatus = (queryData) => {
        return patch(`v1/internal/beneficiaries/${this.uuid}/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }

    /**
     * @memberof Beneficiary
     * @type API
     * @returns Promise
     */
    update = () => {
        let queryData = this.get();
        return put(`v1/internal/beneficiaries/${this.id}/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }

    static download_report = (queryData = {}, config = {}) => {
        return post( 'v1/internal/beneficiaries/reports/', queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }
    /**
     * @memberof Beneficiary
     * @type API
     * @returns Promise
     */
    static verify_vpa = (queryData = {}, config = {}) => {
        return post(`v1/internal/beneficiaries/vpa/verify/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof Beneficiary
     * @type API
     * @returns Promise
     */
    static verify_bank_account = (queryData = {}, config = {}) => {
        return post(`v1/internal/beneficiaries/bank_account/verify/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof Beneficiary
     * @type API
     * @returns Promise
     */
     static verify_fuzzy_match = (queryData = {}, config = {}) => {
          return post(`v1/internal/beneficiaries/bank_account/verify_match/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
     };

    /**
     * @memberof Beneficiary
     * @type Getter Method
     * @takes Beneficiary Params
     * @returns void
     */
    get = () => {
        return {
            id: this.id,
            contact_id: this.contact_id,
            beneficiary_type: this.beneficiary_type,
            beneficiary_name: this.beneficiary_name,
            account_holder_name: this.account_holder_name,
            account_number: this.account_number,
            ifsc: this.ifsc,
            upi_handle: this.upi_handle,
            created_at: this.created_at
        }
    };

    /**
     * @memberof Beneficiary
     * @type Setter Method
     * @takes Beneficiary Params
     * @returns void
     */
    set = (values) => {
        Object.keys(values).forEach(x => this[x] = values[x]);
    };

    /**
     * @memberof Beneficiary
     * @type Setter Method
     * @takes Beneficiary Params
     * @returns void
     */
    reset = () => {
        this.id = undefined;
        this.contact_id = undefined;
        this.beneficiary_type = undefined;
        this.beneficiary_name = undefined;
        this.account_holder_name = undefined;
        this.account_number = undefined;
        this.ifsc = undefined;
        this.upi_handle = undefined;
        this.created_at = undefined;
    };
}